import type { InvoiceInput } from '../../prototype/state/store.ts'
import { proto } from '../../prototype/state/store.ts'
import { financeMutation, financeVersion, uploadFinanceFile } from '../finance/actions.ts'

const version = (id: string) => financeVersion(proto.state.invoices.find((row) => row.id === id))
export const invoiceActions = {
  createInvoice: async (input: InvoiceInput) => {
    const { fileName: _fileName, ...body } = input
    return (await financeMutation<{ id: string }>('/invoices', body, 'POST')).id
  },
  markInvoiceSent: async (id: string, via: string) => {
    await financeMutation(`/invoices/${id}/sent`, { version: version(id), via })
  },
  attachInvoiceFile: async (id: string, file: File) => {
    await uploadFinanceFile(`/invoices/${id}/files`, version(id), file)
  },
  recordInvoicePayment: async (
    id: string,
    input: { amount: string; at: string; method: string; reference: string | null },
  ) => {
    await financeMutation(`/invoices/${id}/payments`, { ...input, version: version(id) })
  },
  reverseInvoicePayment: async (id: string, paymentId: string, reason: string) => {
    await financeMutation(`/invoices/${id}/reverse`, { version: version(id), paymentId, reason })
  },
}
